import { useProfile } from 'providers/UserProfileProvider';

export const Username = () => {
  const profile = useProfile();
  return <>{profile.name}</>;
};
